/**
 * Routes configuration
 */

/**
 * List of route prefixes where the user profile fetch should be skipped.
 * This is typically used for routes that are accessible during onboarding
 * or verification processes where the user might not be fully set up yet,
 * preventing 403 errors and infinite loops.
 */
export const SKIP_USER_FETCH_ROUTES = [
  '/verification',
  '/vereine/create',
  '/choose-plan',
  '/billing/success',
  '/complete-profile',
  '/banned',
  '/user-not-found',
];

/**
 * Checks if the user fetch should be skipped for the given pathname.
 * 
 * @param pathname - The current location pathname
 * @returns true if the user fetch should be skipped
 */
export const shouldSkipUserFetch = (pathname: string): boolean => {
  return SKIP_USER_FETCH_ROUTES.some(route => pathname.startsWith(route));
};
